module.exports = __webpack_public_path__ + "img/11.b770127b.jpg";